import Component from "../abstracts/Component";
import { easter } from "date-easter";
import whatInput from "what-input";

/**
 Date picker component
 */
export default class DatePickerComponent extends Component {
  constructor() {
    super();
    this.changeDateFormat = null;
    this.flatpickerOptions = {
      static: false,
      disableMobile: "true",
      dateFormat: "Y-m-d",
      altInput: true,
      altInputClass: "custom-date",
      position: "auto",
      animate: false,
      onReady: (selectedDates, dateStr, instance) =>
        this.onCalendarReady(instance)
    };
    this.currentInput = whatInput.ask();
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.lastTabNavigation = false;
  }

  get SELECTORS() {
    return {
      datepicker: ".js-datepicker",
      returnOrderProceed: ".js-proceed-to-confirm",
      dateOfBirth: ".js-dateofbirth"
    };
  }

  dateFormatFn(changeDateFormat = false) {
    const currentCountry = document.body.dataset.website;
    const dateFormat = {
      format: "d-m-Y",
      placeholder: "dd-mm-yyyy"
    };
    if (currentCountry?.toLowerCase() === "us") {
      dateFormat.format = "m-d-Y";
      dateFormat.placeholder = "mm-dd-yyyy";
    }
    //console.log(changeDateFormat);
    if (changeDateFormat) {
      dateFormat.format = dateFormat.format.replaceAll("-", "/");
      dateFormat.placeholder = dateFormat.placeholder.replaceAll("-", "/");
    }
    //console.log(dateFormat);
    return dateFormat;
  }

  getLocalization(lang) {
    switch (lang) {
      case "en":
        return "default";
      default:
        return lang;
    }
  }

  reInitDatePicker(moduled, lang, check) {
    const ctx = this;
    // Skip re-initialization on mobile devices
    if (this.isMobile) {
      return;
    }
    
    // reinitialize if we're switching between mouse and TAB navigation
    const currentInputMethod = whatInput.ask();
    const isTabNavigation = (currentInputMethod === 'keyboard' && ctx.lastTabNavigation);
    const wasTabNavigation = (this.currentInput === 'keyboard');
    
    if ((isTabNavigation && this.currentInput === 'mouse') || 
        (currentInputMethod === 'mouse' && wasTabNavigation)) {
      this.currentInput = currentInputMethod;
      $(check).each(function() {
        const _this = $(this);
        if (typeof _this[0]._flatpickr !== "undefined") {
          _this[0]._flatpickr.destroy();
        }
        ctx.createDatePicker(_this);
      });
    }
  }

  bindEvents(moduled, lang, selectors) {
    const ctx = this;
    const htmlNode = document.documentElement; // <html>

    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-whatinput"
        ) {
          ctx.reInitDatePicker(moduled, lang, selectors.datepicker);
        }
      }
    });

    this.$on(
      this.$customEvents.PAGE_LAYOUT_EVENTS.changed,
      ({ event, payload }) => {
        ctx.initDatepicker(moduled, lang, selectors.datepicker);
      }
    );

    // Track TAB key
    if (!this.isMobile) {
      document.addEventListener("keydown", (e) => {
        if (e.key === "Tab") {
          ctx.lastTabNavigation = true;
        }
      });
      
      // Reset TAB flag when clicking with mouse
      document.addEventListener("mousedown", () => {
        ctx.lastTabNavigation = false;
      });
    }

    // Avvia l'osservazione
    observer.observe(htmlNode, {
      attributes: true,
      attributeFilter: ["data-whatinput"]
    });
  }

  isNumeric(input, changeDateFormat = false) {
    // Remove everything that's not a digit
    let digits = input.value.replace(/\D/g, "");

    // Limit to 8 digits (ddmmyyyy)
    digits = digits.slice(0, 8);

    const sep = changeDateFormat ? "/" : "-";

    // Format: dd-mm-yyyy
    if (digits.length >= 5) {
      input.value = `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(
        4
      )}`;
    } else if (digits.length >= 3) {
      input.value = `${digits.slice(0, 2)}-${digits.slice(2)}`;
    } else {
      input.value = digits;
    }
  }

  validateDateFormatOnBlur(input, changeDateFormat = false) {
    const dateString = input.value;
    let regex = /^\d{2}[-]\d{2}[-]\d{4}$/;
    if (changeDateFormat) {
      regex = /^\d{2}[/]\d{2}[/]\d{4}$/;
    }
    const formInput = $(this.SELECTORS.datepicker)[0];
    if (!regex.test(dateString)) {
      //Change calendar view
      if (formInput && formInput._flatpickr) {
        formInput._flatpickr.setDate("");
      }
    }
    if (formInput) {
      formInput.dispatchEvent(new Event("input"));
    }
  }

  validateDateFormat(input, changeDateFormat = false) {
    const dateString = input.value;
    const _dateFormat = this.dateFormatFn(changeDateFormat)?.format;
    let regex = /^\d{2}[-]\d{2}[-]\d{4}$/;
    if (changeDateFormat) {
      regex = /^\d{2}[/]\d{2}[/]\d{4}$/;
    }
    const formInput = $(this.SELECTORS.datepicker)[0];

    if (regex.test(dateString)) {
      const date = flatpickr.parseDate(dateString, _dateFormat);
      //Change calendar view
      if (formInput && formInput._flatpickr) {
        formInput._flatpickr.setDate(date, false);
      }
    }
    if (formInput && document.activeElement !== input) {
      formInput.dispatchEvent(new Event("input"));
    }
  }

  isKeyBoardNavigation() {
    return document.documentElement.dataset.keyboardNavigation === "true";
  }

  setMaxLengthBirthDatePicker() {
    $(this.SELECTORS.datepicker).attr("maxlength", "10");
  }

  getCurrentEasterMonday() {
    let currentEasterMonday;
    const isGLSOrder = document.getElementById("isGLSOrder");
    const country = $("body").data("website");
    const isCountryIT = country != null && country.toLowerCase() === "it";
    if (
      (typeof isGLSOrder !== "undefined" &&
        isGLSOrder !== null &&
        isGLSOrder.value === "true") ||
      isCountryIT
    ) {
      const easterDay = easter(new Date().getFullYear());
      currentEasterMonday = easterDay.day + 1 + "/" + easterDay.month;
    }
    return currentEasterMonday;
  }

  onCalendarReady(instance) {
    const ctx = this;
    const el = instance.input.nextSibling;
    if (!el.placeholder) {
      el?.setAttribute(
        "placeholder",
        ctx.dateFormatFn(ctx.changeDateFormat)?.placeholder
      );
    }
    if (el && instance.input.getAttribute("aria-label")) {
      el.setAttribute("aria-label", instance.input.getAttribute("aria-label"));
    }
    
    // On mobile, don't add keyboard input handlers to prevent conflicts
    if (this.isMobile) {
      return;
    }
    
    let inputTimeout = null;
    
    const onInput = (e) => {
      ctx.isNumeric(el, ctx.changeDateFormat);
      if (inputTimeout) {
        clearTimeout(inputTimeout);
      }
    };
    
    const onKeyUp = (e) => {
      if (inputTimeout) {
        clearTimeout(inputTimeout);
      }
      inputTimeout = setTimeout(() => {
        ctx.validateDateFormat(el, ctx.changeDateFormat);
      }, 300);
    };
    
    const onBlur = () => ctx.validateDateFormatOnBlur(el, ctx.changeDateFormat);
    
    el.removeEventListener("input", onInput);
    el.removeEventListener("keyup", onKeyUp);
    el.removeEventListener("blur", onBlur);
    el.addEventListener("input", onInput);
    el.addEventListener("keyup", onKeyUp);
    el.addEventListener("blur", onBlur);
  }

  disabledDates(date) {
    const exclude = [
      "1/1",
      "6/1",
      "25/4",
      "1/5",
      "2/6",
      "15/8",
      "1/11",
      "8/12",
      "24/12",
      "25/12",
      "26/12",
      "31/12",
      this.getCurrentEasterMonday()
    ];
    const d = date.getDate();
    const m = date.getMonth();
    const dayExclude = d + "/" + (m + 1);
    return (
      date.getDay() === 6 ||
      date.getDay() === 0 ||
      ~$.inArray(dayExclude, exclude)
    );
  }

  createDatePicker(_this) {
    const ctx = this;
    let currentOptions = {};
    const disableweekends = $(_this).data("disableweekends") || false;
    let mindate = Date.parse($(_this).data("mindate"));
    let maxdate = Date.parse($(_this).data("maxdate"));
    ctx.changeDateFormat = $(_this).data("changeDateFormat");

    if (disableweekends) {
      currentOptions = {
        altFormat: ctx.dateFormatFn(ctx.changeDateFormat)?.format,
        minDate: mindate,
        maxDate: maxdate,
        allowInput: false,
        clickOpens: true,
        onChange: function(dateObj, dateStr, instance) {
          if ($("input[name=hourpick]").is(":checked")) {
            $(ctx.SELECTORS.returnOrderProceed).removeClass("disabled");
          }
        },
        disable: [
          function(date) {
            return ctx.disabledDates(date);
          }
        ]
      };
      const hourpickSelected = $("#hourpickSelected").val();
      if (hourpickSelected) {
        $("#hourpick").val(hourpickSelected);
      }
    } else {
      const shouldOpenCalendar = ctx.isMobile ? true : (ctx.currentInput === "mouse");
      
      currentOptions = {
        altFormat: ctx.dateFormatFn(ctx.changeDateFormat)?.format,
        minDate: mindate,
        maxDate: maxdate,
        allowInput: !ctx.isMobile,
        clickOpens: shouldOpenCalendar
      };
    }
    _this.flatpickr({ ...ctx.flatpickerOptions, ...currentOptions });
  }

  initDatepicker(flatpickr, localization, check) {
    const ctx = this;
    $(check).each(function() {
      const _this = $(this);
      ctx.createDatePicker(_this);
    });
  }

  render() {
    const lang =
      this.getLocalization($("html").attr("lang"))?.toLowerCase() ?? "";
    this.moduleLoader.loadFlatpickr(module => {
      this.moduleLoader.loadFlatpickrLocale(
        lang,
        localization => {
          this.initDatepicker(module.default, lang, this.SELECTORS.datepicker);
          this.bindEvents(module.default, lang, this.SELECTORS);
          this.setMaxLengthBirthDatePicker();
        },
        err => console.warn("cant load flatpickr")
      );
    });
  }
}
